import { render, staticRenderFns } from "./Popper.vue?vue&type=template&id=00b0102c&"
import script from "./Popper.vue?vue&type=script&lang=js&"
export * from "./Popper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/fhartwig/orca/workspaces/DIA-3dprima_v2/task-50584/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00b0102c')) {
      api.createRecord('00b0102c', component.options)
    } else {
      api.reload('00b0102c', component.options)
    }
    module.hot.accept("./Popper.vue?vue&type=template&id=00b0102c&", function () {
      api.rerender('00b0102c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/pageDesign/Popper.vue"
export default component.exports